import type { LinkProps } from '@tanstack/react-router';
import { Link } from '@tanstack/react-router';
import * as React from 'react';

import { cn } from '@/lib/utils';

const NavTabs = React.forwardRef<HTMLElement, React.ComponentPropsWithoutRef<'nav'>>(
  ({ className, ...props }, ref) => (
    <nav
      ref={ref}
      className={cn(
        'inline-flex h-10 items-center justify-center rounded-md bg-muted p-1 text-muted-foreground',
        className
      )}
      {...props}
    />
  )
);
NavTabs.displayName = 'NavTabs';

export type NavTabLinkProps = Omit<LinkProps, 'children'> & {
  children: React.ReactNode;
  className?: string;
  hide?: boolean;
};

const NavTabLink = ({ className, hide, children, ...props }: NavTabLinkProps) => {
  if (hide) return null;

  return (
    <Link
      className={cn(
        'inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-background data-[state=active]:text-foreground data-[state=active]:shadow-sm',
        className
      )}
      activeProps={{ 'data-state': 'active', 'aria-current': 'page' }}
      inactiveProps={{ 'data-state': 'inactive' }}
      {...props}
    >
      {children}
    </Link>
  );
};

export { NavTabs, NavTabLink };
